module.exports = __webpack_public_path__ + "static/media/regwiz_122.2fd17331.ico";